<template>
  <div class="captcha-block">
    <div class="captcha-wrapper">
      <div style="height: 100px" id="captcha-container" class="smart-captcha" data-hl="ru"></div>
      <div class="hide-captcha-btn" @click="$emit('hideCaptcha')">
        <img src="../../assets/images/captcha/close.svg" alt="close" />
        <img class="captcha-btn-arrow" src="../../assets/images/captcha/right-arrow.svg" alt="Come back" />
        <span>Вернуться назад</span>
      </div>
    </div>
  </div>
</template>

<script>
import './captcha.scss'
import { loadScript, waitForGlobal } from '@/utils/loadScript'

const SITE_KEY = 'ysc1_QegXSYsQDLhMIffzNxVQPneejSzGuQbn7Goj5yJOa1a6c566'
// Раньше тег стоял в index.html и грузился на каждой странице, включая главную,
// где формы нет вовсе. Капча нужна только здесь — во входе и регистрации, —
// поэтому тянем её в момент показа (RBXGD-1101).
const CAPTCHA_SRC = 'https://smartcaptcha.yandexcloud.net/captcha.js'

export default {
  name: 'CaptchaComponent',
  emits: ['onVerify', 'hideCaptcha'],
  data() {
    return {
      isCaptchaLoaded: false,
      timeToContinue: 8,
      captchaToken: '',
      captchaId: '',
      captchaType: ''
    }
  },
  mounted() {
    this.enableCaptcha()
  },
  methods: {
    // Ждём скрипт, а не проверяем его наличие: до RBXGD-1101 тут стоял ранний
    // выход `if (!window.smartCaptcha) return`, и при незагруженном скрипте
    // капча молча не появлялась — вход ломался без единой ошибки в консоли.
    // Теперь скрипт грузится по требованию, поэтому ждать его обязательно.
    async enableCaptcha() {
      try {
        await loadScript(CAPTCHA_SRC)
        // Событие load говорит, что файл выполнен, но объект smartCaptcha
        // появляется чуть позже — отсюда ожидание глобальной переменной.
        await waitForGlobal('smartCaptcha')
      } catch (error) {
        // Скрипт может не доехать: блокировщик, сеть, недоступность Яндекса.
        // Поведение то же, что было раньше при отсутствии скрипта, — капчи нет,
        // — но теперь это хотя бы видно в консоли, а не проходит бесследно.
        console.error('SmartCaptcha не загрузилась:', error.message)
        return
      }

      // Компонент могли размонтировать, пока грузился скрипт: пользователь
      // закрыл модалку входа. Рендерить капчу в исчезнувший контейнер нельзя.
      if (this._isDestroyed || !document.getElementById('captcha-container')) return

      this.renderCaptcha()
    },
    renderCaptcha() {
      if (!window.smartCaptcha) return

      window.smartCaptcha.render('captcha-container', {
        sitekey: SITE_KEY,
        callback: token => {
          this.$emit('onVerify', token)
        }
      })

      setTimeout(() => {
        this.isCaptchaLoaded = true
      }, 50)
    }
  }
}
</script>
